module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar-home-49937e583a82685978d45a8b525ce207.svg";